<template>
  <div class="layout">
    <media :query="{ minDeviceWidth: 1001 }">
      <div class="banner-wrapper w">
        <banner :courseTypeList="courseTypeList"></banner>
      </div>
    </media>
    <!-- 推荐机构部分 -->
    <media :query="{ minDeviceWidth: 1001 }">
      <block-wrapper
        class="recommend-organ-wrapper w"
        :name="organName"
        :msgRight="msgRight"
        @getMore="getMoreOrgan"
      >
        <div class="recommend-organ">
          <el-row :gutter="28">
            <el-col
              :span="6"
              v-for="item in organData"
              :key="item.id"
              class="item-wrapper"
            >
              <organ-item :organItem="item"></organ-item>
            </el-col>
          </el-row>
        </div>
      </block-wrapper>
    </media>
    <!-- 直播部分 -->
    <media :query="{ minDeviceWidth: 1001 }">
      <block-wrapper
        class="broadcast-live-wrapper w"
        :name="broadcastName"
        msgRight=""
        v-show="broadcasts.length > 0"
      >
        <div class="broadcast-live" v-if="broadcasts.length > 0">
          <div to="/BroadcastDetails" target="_blank" class="broadcastPic">
            <img
              class="course-img"
              v-if="currentBroudCast.courseImgPath"
              :src="currentBroudCast.courseImgPath | filterImageBaseURL(imgUrl)"
              alt="易极云课堂"
              @mouseenter="handleMouseEnter"
            />
            <div
              class="img-mask"
              v-if="isMaskShow"
              @mouseleave="handleMouseLeave"
            >
              <div class="title">{{ currentBroudCast.name }}</div>
              <div class="btn">
                <button @click="handleStudy(currentBroudCast)">立即学习</button>
              </div>
              <div class="course-msg">
                <img
                  :src="
                    currentBroudCast.teacherImgPath | filterImageBaseURL(imgUrl)
                  "
                />
                <p class="teacher-name">
                  教师：<span>{{ currentBroudCast.teacherName }}</span>
                </p>
                <p class="course-name">
                  来自课程：<span>{{ currentBroudCast.courseName }}</span>
                </p>
              </div>
            </div>
          </div>
          <ul class="broadcast-list">
            <div class="line"></div>
            <div
              @click="handleStudy(item)"
              v-for="(item, index) in broadcasts"
              target="_blank"
              @mouseenter="changeActive(item, $event, index)"
              :key="item.id"
              :class="[{ active: currentIndex === index }, 'broadcast-item']"
              ref="broadcast"
            >
              <span class="round" v-if="item.liveVideoStatus !== 2"></span>
              <span class="time text-tip" v-if="item.liveVideoStatus === 2"
                >直播中</span
              >
              <i
                class="iconfont icon-zhibozhong"
                v-if="item.liveVideoStatus === 2"
              ></i>
              <span class="time" v-if="item.liveVideoStatus !== 2">{{
                item.startTime | timefilter
              }}</span>
              <span class="msg">{{ item.name }}</span>
            </div>
          </ul>
        </div>
        <div class="no-broadCast-wrapper" v-else>
          <img src="static/img/noBroadCast.png" class="no-broadCast" />
        </div>
      </block-wrapper>
    </media>
    <!-- 推荐课程部分 -->
    <media :query="{ minDeviceWidth: 1001 }">
      <block-wrapper
        class="recommended-courses-wrapper w"
        :name="courseName"
        :msgRight="msgRight"
        @getMore="getMoreCourse"
      >
        <div class="recommended-courses">
          <div class="kind clearfix"></div>
          <el-row
            :gutter="28"
            class="course-list"
            v-if="recommendCourseArr.length > 0"
          >
            <el-col
              :span="6"
              class="course-item"
              v-for="item in recommendCourseArr"
              :key="item.id"
            >
              <course-item
                :courseItem="item"
                @click.native="goCourse(item)"
              ></course-item>
            </el-col>
          </el-row>
        </div>
      </block-wrapper>
    </media>
    <media :query="{ minDeviceWidth: 1001 }">
      <div class="zm">
        <div class="zmword">合作咨询</div>
        <div class="divform">
          <el-form :model="form" :rules="rules" ref="form" class="form">
            <el-form-item label="" prop="name">
              <input v-model="form.name" placeholder="姓名" />
            </el-form-item>
            <el-form-item label="" prop="contact">
              <input v-model="form.contact" placeholder="手机号" />
            </el-form-item>
            <el-form-item label="" prop="area">
              <input v-model="form.area" placeholder="城市" />
            </el-form-item>
          </el-form>
          <!--<a class="jr" @click="saveContent('form')">申请加入</a>-->
          <button class="jr" @click="saveContent('form')">申请加入</button>
        </div>
      </div>
    </media>

    <!-- 手机网站 -->
    <media :query="{ maxDeviceWidth: 1000 }">
      <div class="wap">
        <!-- 头部-->
        <div class="waptop">
          <div class="waptop-logo" @click="browserRedirect">
            <img src="../../../static/img/wapimg/logo.png" />
          </div>
          <div class="waptop-right" @click="gosearch">
            <img src="../../../static/img/wapimg/wap-search.png" />
          </div>
        </div>
        <!-- 轮播图-->
        <div class="banner">
          <slider></slider>
        </div>

        <div class="clearfix"></div>
        <!-- 课程类别-->
        <div class="casetype">
          <sidebar :courseTypeList="courseTypeList"></sidebar>
        </div>
        <div style="width: 100%; height: 0.8rem; background: #f3f4f8"></div>
        <!-- 推荐课程-->
        <div class="recommended-courses">
          <div class="courses-tit">推荐课程</div>
          <ul v-if="waprecommendCourseArr.length > 0">
            <li v-for="item in waprecommendCourseArr" :key="item.id">
              <wap-course-item
                :courseItem="item"
                @click.native="goCourse(item)"
              ></wap-course-item>
            </li>
          </ul>
        </div>

        <!-- 底部导航-->
        <div class="mw-footer j-mw-footer">
          <div class="um-common-footer">
            <a class="um-common-footer_item" @click="backindex">
              <div class="um-common-footer_item_icon">
                <img src="../../../static/img/wapimg/icohome-fill.png" />
              </div>
              <div class="um-common-footer_item_text">首页</div>
            </a>

            <a class="um-common-footer_item" @click="backcourse">
              <div class="um-common-footer_item_icon">
                <img src="../../../static/img/wapimg/icobooks.png" />
              </div>
              <div class="um-common-footer_item_text">课程</div>
            </a>

            <a class="um-common-footer_item" @click="backcenter">
              <div class="um-common-footer_item_icon">
                <img src="../../../static/img/wapimg/icowode.png" />
              </div>
              <div class="um-common-footer_item_text">我的</div>
            </a>
          </div>
        </div>
      </div>
    </media>
  </div>
</template>
<script>
import Banner from "./components/banner";

import Slider from "./components/wapslider";
import Sidebar from "./components/wapsidebar";
import WapCourseItem from "@/components/course-item/wapcourse-item";

import BlockWrapper from "@/components/block-wrapper/block-wrapper";
import OrganItem from "@/components/organ-item/organ-item";
import CourseItem from "@/components/course-item/course-item";
import { fetchRecommendOrgan, getOrganList } from "@/api/organ.js";
import { getBroadCastList } from "@/api/broadcast.js";
import { changeOrgan } from "@/common/js/organ.js";
import { fetchCourseType, fetchReCommendCourse } from "@/api/course.js";
import { changeCourseId } from "@/common/js/course.js";
import { changeCourseList } from "@/common/js/courseTypeList.js";
import { mapGetters, mapMutations } from "vuex";
import { changeCourseItem } from "@/common/js/courseType.js";
import { getUserMixin } from "@/common/js/mixin.js";
import { getToken, setToken } from "@/common/js/auth.js";
import global from "@/common/js/global";
import axios from "axios";
import storage from "good-storage";
import { fetchthrdlogin } from "@/api/login.js";
import { validatePhone } from "@/utils/validate.js";
import { fetchrecruit } from "@/api/recruit";
import Media from "vue-media";
const USER = "__user__";
export default {
  mixins: [getUserMixin],
  data() {
    var validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入电话号码"));
      } else if (!validatePhone(value)) {
        callback(new Error("请输入正确的11位手机号码"));
      } else {
        callback();
      }
    };
    return {
      // clientHeight: '',
      // timer: null,
      // showzm: false,
      // showzm1: true,
      form: {
        name: "",
        contact: "",
        area: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: ["blur", "change"] }
        ],
        contact: [
          { required: true, validator: validPhone, trigger: ["blur", "change"] }
        ],
        area: [
          { required: true, message: "请输入城市", trigger: ["blur", "change"] }
        ]
      },
      code: this.$route.query.code,
      state: this.$route.query.state,
      broadcasts: [],
      slidePiclist: [1, 2, 3, 4, 5],
      organName: "推荐机构",
      msgRight: "全部",
      broadcastName: "最近直播",
      sourseName: "推荐课程",
      courseName: "推荐课程",
      broadcastUrl: "",
      organData: [],
      organTemp: [],
      courseData: [],
      courseTemp: [],
      flag: 0,
      courseId: "first",
      blockShow: false,
      currentIndex: 0,
      courseTypeList: [],
      recommendCourseArr: [],
      waprecommendCourseArr: [],
      courseCurrentIndex: 0,
      goOrganClassfyParam: {
        orgTypeId: "0",
        pageNo: 1,
        isRecommend: 1
      },
      gocourseClassfyParam: {
        pageNo: 1,
        isRecommend: 1
      },

      currentBroudCast: {
        id: "",
        msg: "",
        courseImgPath: "",
        teacherImgPath: "",
        teacherName: "",
        courseName: "",
        courseId: ""
      },
      isMaskShow: false,
      imgUrl: global.imgUrl
    };
  },
  created() {
    this.getAll();
    let uri = window.location.href;
    let params = uri.split("?");
    if (params.length > 1) {
      let code = params[1].split("&")[0].split("=")[1];
      let state = params[1]
        .split("&")[1]
        .split("=")[1]
        .replace("#/", "");
      if (!getToken()) {
        if (code != null || code != undefined) {
          if (state == "weixin") {
            if (code != null || code != undefined) {
              axios({
                headers: {
                  "X-Requested-With": "XMLHttpRequest",
                  "Content-Type": "application/json; charset=UTF-8",
                  "Access-Control-Allow-Origin": "*"
                }, //设置跨域请求头
                method: "post", //请求方式
                url: process.env.BASE_API + "/userThirdAuths/weiXinLogin", //请求地址
                data: code
              })
                .then(response => {
                  if (!response || response.data.status !== 200) {
                    this.$message.error(response.data.message);
                    return;
                  }
                  let res = response.data;
                  this.$message({
                    message: "登录成功！",
                    type: "success"
                  });
                  // 保存到token和vuex里面
                  setToken(res.data.userToken);
                  // 将用户的基本信息进行保存
                  storage.set(USER, res.data);
                  this.setStoreUser(res.data);
                  // 保存用户id
                  this.setUserId(res.data.id);
                })
                .catch(function(err) {
                  console.log(err);
                });
            }
          }
        }
      }
    }
    let paramsqq = uri.split("&");
    if (paramsqq.length > 1) {
      let qqcode = paramsqq[1].split("&")[0].split("=")[1];
      let qqstate = paramsqq[2]
        .split("&")[0]
        .split("=")[1]
        .replace("#/", "");
      if (!getToken()) {
        if (qqcode != null || qqcode != undefined) {
          if (qqstate == "qq") {
            // console.log('测试是否到三方登录QQ' + qqstate)
            if (qqcode != null || qqcode != undefined) {
              axios({
                headers: {
                  "X-Requested-With": "XMLHttpRequest",
                  "Content-Type": "application/json; charset=UTF-8",
                  "Access-Control-Allow-Origin": "*"
                }, //设置跨域请求头
                method: "post", //请求方式
                url: process.env.BASE_API + "/userThirdAuths/qqLogin", //请求地址
                data: qqcode
              })
                .then(response => {
                  if (!response || response.data.status !== 200) {
                    this.$message.error(response.data.message);
                    return;
                  }
                  let res = response.data;
                  this.$message({
                    message: "登录成功！",
                    type: "success"
                  });
                  // 保存到token和vuex里面
                  setToken(res.data.userToken);
                  // 将用户的基本信息进行保存
                  storage.set(USER, res.data);
                  this.setStoreUser(res.data);
                  // 保存用户id
                  this.setUserId(res.data.id);
                  // 如果有form跳转到详情页  objfrom
                  // if (uri.indexOf('objfrom')>= 0) {
                  //   let id = paramsqq[3].split('&')[0].split('=')[1].replace('#/', '');
                  //   let orgInfoId = paramsqq[4].split('&')[0].split('=')[1].replace('#/', '');
                  //   let distributionUserId = paramsqq[5].split('&')[0].split('=')[1].replace('#/', '');
                  //   let orgId = paramsqq[6].split('&')[0].split('=')[1].replace('#/', '');
                  //     let routeData = this.$router.resolve({ path: '/CourseDetails', query:{ id: id, orgInfoId: orgInfoId, distributionUserId: distributionUserId, orgId: orgId } })
                  //     window.open(routeData.href, '_self')
                  // }
                  // 如果有form
                })
                .catch(function(err) {
                  console.log(err);
                });
            }
            // console.log(qqstate + 'qq')
          }
        }
      }
    }
  },
  filters: {
    timefilter(val) {
      return val.slice(5, -3);
    }
  },
  components: {
    Banner,
    Slider,
    Sidebar,
    WapCourseItem,
    BlockWrapper,
    OrganItem,
    CourseItem,
    Media
  },
  computed: {
    ...mapGetters(["user"])
  },
  mounted() {
    // 获取浏览器可视区域高度
    // this.clientHeight = `${document.documentElement.clientHeight}`
    // window.onresize = function temp () {
    //   this.clientHeight = `${document.documentElement.clientHeight}`
    // }
    // window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    // s手机端
    browserRedirect() {
      // console.log(111111111)
      window.location.href =
        "http://soeasyit.cn:8080/html5/yjykt_shares/shareCourse/erwm.html";
      // var u = navigator.userAgent;
      // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      // var iOSis_1 = u.indexOf('ios') > -1; //ios终端
      // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // if (isAndroid) {
      //   window.location.href="http://18102435407.fx.sj.360.cn/qcms/view/t/detail?id=4015837";
      // }
      // if (isiOS||iOSis_1) {
      //   window.location.href="https://itunes.apple.com/cn/app/id1436118843?l=zh&ls=1&mt=8";
      // }
    },
    gosearch() {
      this.$router.push({ path: "/wapsearchcourse" });
    },
    // s手机端

    // handleScroll () {
    //   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    //   if (scrollTop > (this.clientHeight - 120)) {
    //     this.showzm = true
    //   } else {
    //     this.showzm = false
    //   }
    //   // console.log(scrollTop)
    // },
    // guanbi () {
    //   this.showzm = false
    //   this.showzm1 = false
    // },
    resetTemp() {
      this.form = {
        name: "",
        contact: "",
        area: ""
      };
    },

    saveContent(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            name: this.form.name,
            contact: this.form.contact,
            area: this.form.area,
            status: 0
          };
          fetchrecruit(obj).then(res => {
            this.resetTemp();
            this.$message({
              message: "提交成功！",
              type: "success"
            });
          });
        } else {
          this.$message.error("验证未通过，请查看信息填写是否完整");
          return false;
        }
      });
    },

    // 鼠标进入直播
    handleMouseLeave() {
      this.isMaskShow = false;
    },
    //
    handleMouseEnter() {
      this.isMaskShow = true;
    },
    /**
     * 修改样式
     */
    changeActive(item, event, index) {
      this.currentIndex = index;
      if (this.broadcasts[index]) {
        this.currentBroudCast = this.broadcasts[index];
      }
      document
        .querySelector(".broadcast-item.active")
        .classList.toggle("active");
      event.currentTarget.classList.add("active");
      this.broadcastUrl = item.src;
    },

    // 获取直播列表
    getBroadCastList() {
      getBroadCastList().then(res => {
        if (!res || res.status !== 200) {
          this.open(res.message);
          return;
        }
        try {
          this.broadcasts = res.data.todayCourse;
          if (!this.broadcasts) {
            this.broadcasts = res.data.futureCourse;
          } else {
            this.broadcasts = this.broadcasts.concat(res.data.futureCourse);
          }
          if (this.broadcasts.length > 7) {
            this.broadcasts.splice(7);
          }
          if (this.broadcasts[0]) {
            this.currentBroudCast = this.broadcasts[0];
          }
        } catch (error) {
          console.log(error);
        }
      });
    },
    /**
     * 消息提示
     */
    open(msg) {
      this.$message.error(msg);
    },
    // 点击机构更多
    getMoreOrgan() {
      let routeData = this.$router.resolve({
        path: "/OrganClass",
        query: this.goOrganClassfyParam
      });
      window.open(routeData.href, "_self");
    },

    //点击机构更多
    getMoreCourse() {
      let routeData = this.$router.resolve({
        path: "/CourseClass",
        query: this.gocourseClassfyParam
      });
      window.open(routeData.href, "_self");
    },
    // browserRedirect() {
    //   var sUserAgent = navigator.userAgent.toLowerCase();
    //   var bIsIpad = sUserAgent.match(/ipad/i) == 'ipad';
    //   var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os';
    //   var bIsMidp = sUserAgent.match(/midp/i) == 'midp';
    //   var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i ) == 'rv:1.2.3.4 ';
    //   var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb';
    //   var bIsAndroid = sUserAgent.match(/android/i) == 'android';
    //   var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce';
    //   var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile';
    //   var u = navigator.userAgent;
    //   var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    //   var iOSis_1 = u.indexOf('ios') > -1; //ios终端
    //   var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    //   if (isAndroid || isiOS|| iOSis_1||bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
    //     this.$router.push({path: '/iphonedownload'})
    //     // window.location.href = '/iphonedownload';
    //   }
    // },
    //
    // 立即学习
    // id是小节id
    handleStudy(itemch) {
      let obj = {};
      if (itemch.chatroomId && !itemch.ossUrl) {
        obj = {
          id: itemch.id,
          chatroomId: itemch.chatroomId,
          liveVideoStatus: itemch.liveVideoStatus
        };
        let routeData = this.$router.resolve({
          path: "/ChapterDetails",
          query: obj
        });
        window.open(routeData.href, "_blank");
        // let url = 'https://www.soeasyit.cn/plive/index.html?partDetailId=' + itemch.id
        // window.open(url, '_blank')
      } else {
        obj = {
          id: itemch.id
        };
        let routeData = this.$router.resolve({
          path: "/ChapterDetails",
          query: obj
        });
        window.open(routeData.href, "_blank");
      }
    },
    ...mapMutations({
      setCourseId: "SET_COURSEID",
      setStoreUser: "SET_USER",
      setUserId: "SET_USERID"
    }),

    goCourse(item) {
      // let routeData = this.$router.resolve({ path: '/CourseDetails', query: item })
      // console.log("item.linkType :>> ", item.linkType);
      if (item.hasOwnProperty("linkType") && item.linkType === 1) {
        window.open(item.linkUrl, "_blank");
        return;
      }
      let routeData = this.$router.resolve({
        path: "/CourseDetails",
        query: { id: item.id, orgInfoId: item.orgInfoId }
      });
      window.open(routeData.href, "_self");
    },

    // 获取课程分类
    getCourseType() {
      fetchCourseType().then(res => {
        this.courseTypeList = res.data.rows.slice(0, 7);
      });
    },

    // 获取推荐机构
    getRecommendOrgan() {
      // fetchRecommendOrgan(1, 4, 1, 1, 1).then(res => {
      //   this.organTemp = res.data.rows
      //   let organDataTemp = []
      //   this.organTemp.forEach(function (item, index) {
      //     // 将item里面的内容重新封装成一个对象进行存储
      //     organDataTemp.push(changeOrgan(item))
      //   })
      //   // 这儿是推荐机构处理后的数据
      //   // 通过中间量的形式，保证每次this.organData都是最新的值
      //   this.organData = organDataTemp
      // }).catch(function (error) {
      //   // console.log(error)
      // })
      let obj = {
        pageSize: 4,
        pageNo: 1,
        isRecommend: 1
      };
      if (this.user) {
        obj.userId = this.user.id;
      }
      getOrganList(obj)
        .then(res => {
          this.organTemp = res.data.rows;
          let organDataTemp = [];
          this.organTemp.forEach(function(item, index) {
            // 将item里面的内容重新封装成一个对象进行存储
            organDataTemp.push(changeOrgan(item));
          });
          // 这儿是推荐机构处理后的数据
          // 通过中间量的形式，保证每次this.organData都是最新的值
          this.organData = organDataTemp;
        })
        .catch(function(error) {
          // console.log(error)
        });
    },
    // 获取推荐课程
    getRecommendCourse() {
      let obj = {
        pageSize: 8,
        pageNo: 1
      };
      if (this.user) {
        obj.userId = this.user.id;
      }
      fetchReCommendCourse(obj).then(res => {
        this.recommendCourseArr = res.data.rows;
      });
    },
    // 获取推荐课程手机端
    getwapRecommendCourse() {
      let obj = {
        pageSize: 50,
        pageNo: 1
      };
      if (this.user) {
        obj.userId = this.user.id;
      }
      fetchReCommendCourse(obj).then(res => {
        this.waprecommendCourseArr = res.data.rows;
      });
    },
    getAll() {
      // // 请求推荐机构的内容
      this.getCourseType();
      // // 获取推荐机构
      this.getRecommendOrgan();

      // this.browserRedirect()
      // // 获取推荐课程
      this.getRecommendCourse();
      // 获取推荐课程手机端
      this.getwapRecommendCourse();
      // 获取直播列表
      this.getBroadCastList();
    },

    // 手机端 导航调整
    backindex() {
      let routeData = this.$router.resolve({ path: "/" });
      window.open(routeData.href, "_self");
    },
    backcourse() {
      if (!getToken()) {
        let obj = {
          from: this.$route.path,
          type: "login",
          ...this.$route.query
        };
        this.$router.push({ path: "/Login", query: obj });
      } else {
        let routeData = this.$router.resolve({ path: "/wapmycourse" });
        window.open(routeData.href, "_self");
      }
    },
    backcenter() {
      if (!getToken()) {
        let obj = {
          from: this.$route.path,
          type: "login",
          ...this.$route.query
        };
        this.$router.push({ path: "/Login", query: obj });
      } else {
        let routeData = this.$router.resolve({ path: "/wapmycenter" });
        window.open(routeData.href, "_self");
      }
    }
    // 手机端 导航调整
  },
  watch: {
    $route(to, from) {
      if (!getToken()) {
        if (
          this.$route.query.code != null ||
          this.$route.query.code != undefined
        ) {
          if (this.$route.query.state == "weixin") {
            if (
              this.$route.query.code != null ||
              this.$route.query.code != undefined
            ) {
              axios({
                headers: {
                  "X-Requested-With": "XMLHttpRequest",
                  "Content-Type": "application/json; charset=UTF-8",
                  "Access-Control-Allow-Origin": "*"
                }, //设置跨域请求头
                method: "post", //请求方式
                url: "/userThirdAuths/weiXinLogin", //请求地址
                data: this.$route.query.code
              })
                .then(response => {
                  if (!response || response.data.status !== 200) {
                    this.$message.error(response.data.message);
                    return;
                  }
                  let res = response.data;
                  this.$message({
                    message: "登录成功！",
                    type: "success"
                  });
                  // 保存到token和vuex里面
                  setToken(res.data.userToken);
                  // 将用户的基本信息进行保存
                  storage.set(USER, res.data);
                  this.setStoreUser(res.data);
                  // 保存用户id
                  this.setUserId(res.data.id);
                })
                .catch(function(err) {
                  console.log(err);
                });
            }
          } else {
            if (
              this.$route.query.code != null ||
              this.$route.query.code != undefined
            ) {
              axios({
                headers: {
                  "X-Requested-With": "XMLHttpRequest",
                  "Content-Type": "application/json; charset=UTF-8",
                  "Access-Control-Allow-Origin": "*"
                }, //设置跨域请求头
                method: "post", //请求方式
                url: "/userThirdAuths/qqLogin", //请求地址
                data: this.$route.query.code
              })
                .then(response => {
                  if (!response || response.data.status !== 200) {
                    this.$message.error(response.data.message);
                    return;
                  }
                  let res = response.data;
                  this.$message({
                    message: "登录成功！",
                    type: "success"
                  });
                  // 保存到token和vuex里面
                  setToken(res.data.userToken);
                  // 将用户的基本信息进行保存
                  storage.set(USER, res.data);
                  this.setStoreUser(res.data);
                  // 保存用户id
                  this.setUserId(res.data.id);
                })
                .catch(function(err) {
                  console.log(err);
                });
            }
          }
        }
      }
    }
    // clientHeight (val) {
    //   if (!this.timer) {
    //     this.clientHeight = val
    //     // console.log(this.clientHeight)
    //     this.timer = true
    //     let that = this
    //     setTimeout(function (){
    //       that.timer = false
    //     }, 400)
    //   }
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
@import "~@/styles/base.scss";
.gb {
  display: inline-block;
  color: #acafaf;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  position: absolute;
  top: 0px;
  right: 20px;
  font-size: 24px;
}
.zm {
  /*left: 0;*/
  /*position: fixed;*/
  /*z-index: 99999;*/
  height: 120px;
  /*bottom: 0px;*/
  background: #f8f8f8;
  margin-top: 40px;
  /*background: rgba(0, 0, 0, 0.74);*/
  width: 100%;
  .zmword {
    width: 1200px;
    margin: 0 auto;
    height: 80px;
    line-height: 80px;
    text-align: left;
    color: #5b5b5b;
    font-size: 24px;
    font-family: 微软雅黑;
  }
  .divform {
    width: 1200px;
    margin: 0 auto;
    height: 40px;
    .jr {
      border: none;
      margin-left: 18px;
      float: left;
      width: 175px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      background: #cccccc;
      color: #fff;
      font-size: 16px;
      font-family: 微软雅黑;
    }
    .form {
      width: 1007px;
      height: 40px;
      float: left;
      .el-form-item {
        margin-bottom: 0px;
        width: 300px;
        float: left;
        margin-right: 30px;
      }
      input {
        width: 290px;
        padding-left: 20px;
        height: 40px;
        line-height: 40px;
        color: #858585;
        background-color: #fefefe;
        border: 1px #cccccc solid;
      }
      input:after {
        border: 1px #cccccc solid;
      }
    }
  }
}

.layout {
  margin-top: 30px;
  /*padding-bottom: 30px;*/
  .banner-wrapper {
    height: 450px;
    .banner {
      height: 450px;
    }
  }
  .recommend-organ-wrapper {
    margin-top: 40px;
    .recommend-organ {
      margin-top: 20px;
      height: 365px;
      .el-row {
        height: 365px;
        .el-col {
          height: 365px;
        }
      }
      .item-wrapper {
        &:hover {
          transition: all 0.3s;
          transform: translate3d(0, -5px, 0);
          // box-shadow: 0 0 3px #ddd;
        }
      }
    }
  }
  .broadcast-live-wrapper {
    margin-top: 40px;
    .broadcast-live,
    .no-broadCast-wrapper {
      display: flex;
      margin-top: 20px;
      height: 360px;
      box-shadow: 0 0 8px #ddd;
      .broadcastPic {
        width: 600px;
        float: left;
        position: relative;
        .course-img {
          width: 600px;
          height: 360px;
        }
        .img-mask {
          position: absolute;
          left: 0;
          top: 0;
          width: 600px;
          height: 360px;
          z-index: 200;
          overflow: hidden;
          background-color: rgba(10, 10, 10, 0.8);
          .title {
            margin-top: 100px;
            padding: 0 20px;
            font-size: 18px;
            color: #fcfcfc;
            text-align: center;
            line-height: 2em;
          }
          .btn {
            position: absolute;
            top: 190px;
            height: 50px;
            width: 100%;
            text-align: center;
            button {
              outline-color: none;
              border: none;
              width: 180px;
              height: 50px;
              border-radius: 5px;
              cursor: pointer;
              color: #fff;
              font-size: 16px;
              line-height: 50px;
              background-color: $layoutBlue;
            }
          }
          .course-msg {
            position: absolute;
            padding: 4px 0;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 70px;
            background-color: rgba(20, 20, 20, 0.4);
            img {
              margin: 0 10px;
              width: 62px;
              height: 62px;
              vertical-align: middle;
              border-radius: 50%;
            }
            .teacher-name {
              display: inline-block;
              vertical-align: middle;
              font-size: 18px;
              height: 62px;
              line-height: 62px;
              color: #fcfcfc;
              span {
                display: inline-block;
                // margin-left: 5px;
                vertical-align: middle;
                width: 150px;
                height: 62px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .course-name {
              position: absolute;
              left: 345px;
              top: 4px;
              height: 62px;
              line-height: 62px;
              font-size: 18px;
              color: #fcfcfc;
              vertical-align: middle;
              span {
                display: inline-block;
                vertical-align: middle;
                // margin-left: 5px;
                width: 152px;
                height: 62px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
      .broadcast-list {
        flex: 1;
        float: left;
        position: relative;
        .line {
          position: absolute;
          top: 0;
          left: 37px;
          height: 360px;
          border-left: 1px dotted #bbd9ff;
        }
        .broadcast-item {
          position: relative;
          display: block;
          padding-left: 200px;
          height: 51.4px;
          font-size: 16px;
          line-height: 51.4px;
          cursor: pointer;
          .time {
            position: absolute;
            line-height: 51.4px;
            left: 51.4px;
            top: 0;
          }
          .msg {
            display: inline-block;
            width: 300px;
            line-height: 60px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .round {
            position: absolute;
            left: 32px;
            top: 23px;
            content: "";
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #ccc;
          }
          .iconfont {
            position: absolute;
            left: 32px;
          }
          .iconfont,
          .text-tip {
            color: $layoutBlue;
          }
          &.active {
            color: $layoutBlue !important;
            .round {
              background-color: $layoutBlue;
            }
            background-color: rgba(230, 230, 230, 0.3);
          }
          // &:hover {
          //   color: $layoutBlue !important;
          // }
          .player {
            position: absolute;
            left: 25px;
            // top: 8px;
            font-size: 25px;
          }
        }
      }
    }
    .no-broadCast-wrapper {
      overflow: hidden;
      text-align: center;
      .no-broadCast {
        height: 360px;
      }
    }
  }
  .recommended-courses-wrapper {
    margin-top: 40px;
    .recommended-courses {
      margin-top: 20px;
      position: relative;
      .kind {
        position: absolute;
        right: 0;
        top: -65px;
        font: 14px/40px "microsoft yahei";
        // background-color: red;
        .choose-course {
          // background-color: red;
          margin: 0 10px;
          float: left;
          transition: all 0.3s;
          border-color: rgba(0, 0, 0, 0);
          &.active {
            border-bottom: 3px solid rgba(129, 163, 235, 1);
          }
          &:hover {
            cursor: pointer;
            color: blue;
          }
        }
      }
      .course-list {
        height: 480px;
        // background-color: pink;
        .course-item {
          cursor: pointer;
          height: 240px;
          &:hover {
            transition: all 0.3s;
            transform: translate3d(0, -5px, 0);
          }
        }
      }
    }
  }
  .loading-container {
    position: absolute;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
  }
}
.wap {
  .waptop {
    width: 90%;
    margin: 0 auto;
    height: auto;
    .waptop-logo {
      float: left;
      width: 80%;
      height: auto;
      overflow: hidden;
      img {
        max-width: 100%;
        height: auto;
      }
    }
    .waptop-right {
      float: right;
      width: 20%;
      height: auto;
      overflow: hidden;
      text-align: right;
      img {
        max-width: 40%;
        height: auto;
      }
    }
  }
  .banner {
    width: 100%;
    /*max-height: 200px;*/
    /*height: auto;*/
    height: 200px;
    text-align: center;
    overflow: hidden;
    margin-top: 0.8rem;
    float: left;
    img {
      width: 100%;
      /*height: auto;*/
      height: 200px;
    }
  }
  .casetype {
    width: 90%;
    margin: 0 auto;
    height: auto;
    margin-top: 0.6rem;
    margin-bottom: 0.6rem;
  }
  .recommended-courses {
    width: 90%;
    margin: 0 auto;
    height: auto;
    margin-top: 0.6rem;
    margin-bottom: 0.6rem;
    .courses-tit {
      padding-top: 0.6rem;
      margin-bottom: 1rem;
      font-size: 1.2rem;
      height: auto;
      color: #3a4853;
    }
    ul {
      float: left;
      width: 100%;
      margin-bottom: 4rem;
    }
    ul li {
      float: left;
      width: 48%;
      height: 8rem;
      margin-bottom: 2rem;
    }
    ul li:nth-child(2n + 1) {
      margin-right: 4%;
    }
  }
  /*.footer{*/
  /*position: fixed;*/
  /*bottom: 0;*/
  /*width: 100%;*/
  /*height: 60px;*/
  /*border-top: 1px #f0f0f0 solid;*/
  /*z-index: 999;*/

  /*}*/
  .mw-footer {
    margin-top: 3rem;
    padding-bottom: 0.2rem;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    z-index: 100;
    position: fixed;
    bottom: 0;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
  .mw-footer .um-common-footer {
    display: -webkit-box;
    display: -moz-box;
    display: box;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -moz-box-align: center;
    box-align: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    align-items: center;
    -ms-flex-align: center;
    -webkit-box-pack: center;
    -moz-box-pack: center;
    box-pack: center;
    -webkit-justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -o-justify-content: center;
    justify-content: center;
    -ms-flex-pack: center;
    -webkit-box-orient: horizontal;
    -moz-box-orient: horizontal;
    box-orient: horizontal;
    -webkit-box-direction: normal;
    -moz-box-direction: normal;
    box-direction: normal;
    -webkit-flex-direction: row;
    -moz-flex-direction: row;
    flex-direction: row;
    -ms-flex-direction: row;
    height: 100%;
    width: 100%;
    border-top: 1px solid #f0f0f0;
    height: 3.5rem;
  }
  .mw-footer .um-common-footer_item {
    flex: 1;
    height: 100%;
    color: #3c4a55;
    text-decoration: none;
    display: -webkit-box;
    display: -moz-box;
    display: box;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    box-orient: vertical;
    -webkit-box-direction: normal;
    -moz-box-direction: normal;
    box-direction: normal;
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    flex-direction: column;
    -ms-flex-direction: column;
    -webkit-box-align: center;
    -moz-box-align: center;
    box-align: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    align-items: center;
    -ms-flex-align: center;
    -webkit-box-pack: center;
    -moz-box-pack: center;
    box-pack: center;
    -webkit-justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -o-justify-content: center;
    justify-content: center;
    -ms-flex-pack: center;
  }
  .mw-footer .um-common-footer_item_icon {
    width: 1.5rem;
    font-size: 0.56rem;
    margin-top: 0.5rem;
    img {
      width: 100%;
      height: auto;
    }
  }
  .mw-footer .um-common-footer_item_text {
    font-size: 0.8rem;
    margin-top: 0.05333rem;
    color: #3c4a55;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue